import { camelizeResource, pascalizeResource } from '../../helpers/resource';

export const getSurvey = props => ({
  ...camelizeResource(props),
  questionList: props.QuestionList.map(question => ({
    ...camelizeResource(question),
    answerList: question.AnswerList.map(camelizeResource),
  })),
});

export const postSurvey = props => Object.keys(props.answers).map(questionId => ({
  SurveyId: props.survey.surveyId,
  SiteId: props.survey.siteId,
  QuestionId: questionId,
  AnswerId: props.answers[questionId],
}));



// WEBPACK FOOTER //
// ./src/resources/tara/normalizers.js